{"errno":-4058,"code":"ENOENT","syscall":"open","path":"C:\\Users\\Connor\\Documents\\Github\\vscode-regexpp\\.temp\\src\\reader.ts"}